export const excelFormats = [
  '.xlsx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const grades = ["初小", "高小", "初中", "高中"];
export const difficulties = ["基礎", "中級", "進階"];
export const diffColors = ['green', 'yellow', 'red'];